// DeleteModal.tsx

import React from "react";
import { Button, Modal } from "@mui/material";


interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1/3
       max-w-screen-md bg-white shadow-lg px-8 pt-4 rounded-lg h-auto"
      >
        <h2 className="text-lg md:text-xl font-semibold  text-primary">
          {title}
        </h2>
        <p className="text-base font-semibold mt-2">{message}</p>
        <div className="flex justify-between items-center mt-4">
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{ border: `1px solid primary`, textTransform: "none", marginBottom: "20px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{ color: "white", textTransform: "none", marginBottom: "20px" }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
